import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private loadingSubj = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubj.asObservable();

  setLoading(isLoading: boolean) {
    this.loadingSubj.next(isLoading);
  }
}
